<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('lot_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="lot_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('amount')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="amount" type="number"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('bidder_uuid')">
              <customer-select-input-widget v-if="enableContinuousAuction" @select="onCustomerSelect"
                                            :model="searchModel"
                                            :label="false"
                                            :options="{placeholder: $t('Customer')}"
                                            attribute="customer_uuid" is-search/>
              <bidder-select-input-widget v-else :model="searchModel" attribute="bidder_uuid" @select="onBidderSelect"
                                          :auction-uuid="extraFilters.auction_uuid" is-search
                                          :lot-uuid="extraFilters.lot_uuid"
                                          value-field="uuid"
                                          :label="false" :options="{placeholder: $t('Bidder')}"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('stock_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="stock_no"/>
            </div>
            <div class="input-wrapper d-flex flex-row"
                 v-if="!excludeSearchFields.includes('is_winner') || !excludeSearchFields.includes('highest_bid')">
              <input-widget :model="searchModel" attribute="is_winner" type="checkbox" class="mr-3"
                            v-if="!excludeSearchFields.includes('is_winner')"/>
              <input-widget :model="searchModel" attribute="highest_bid" type="checkbox"
                            v-if="!excludeSearchFields.includes('highest_bid')"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import BidderSelectInputWidget from "@/core/widgets/BidderSelectInputWidget";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('bids');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "BidSearch",
    components: {CustomerSelectInputWidget, BidderSelectInputWidget, InputWidget},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({customer});
      },
      async onBidderSelect(bidder) {
        this.updateSearchModel({bidder});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
